import React from 'react';

import { noop } from 'lodash';
import { shape, func, string } from 'prop-types';

import withFileInput from 'containers/withFileInput';

import commonUpload from 'utils/commonUpload';
import { ensureObject } from 'utils/objects';

import s from './FileInput.css';

const FileInputRoot = ({
  ariaLabel,
  fileInput: { inputProps },
  setFile,
  setUploading,
  setError,
}) => {
  const {
    onUploadStart = noop,
    onUploadComplete = noop,
    accept,
    allowImageBasedPdf = false,
  } = ensureObject(inputProps);
  return (
    <input
      aria-label={ariaLabel}
      type="file"
      id="FileInputRoot"
      className={s.input}
      onChange={async e => {
        e.persist();
        setUploading(true);
        onUploadStart();
        const singleFile = e.target.files[0];
        const { key, file, error } = await commonUpload(
          singleFile,
          undefined,
          allowImageBasedPdf,
        );
        if (error) {
          setError(error);
        } else {
          const name = file.split('?')[0].split('/').pop();
          setFile({
            key,
            path: file,
            name,
          });
          onUploadComplete({ key, file, name });
        }
        setUploading(false);
        e.target.value = '';
      }}
      accept={accept}
    />
  );
};

FileInputRoot.propTypes = {
  ariaLabel: string,
  fileInput: shape({}).isRequired,
  setFile: func.isRequired,
  setUploading: func.isRequired,
  setError: func.isRequired,
};

FileInputRoot.defaultProps = {
  ariaLabel: 'Upload file',
};

export default withFileInput(FileInputRoot);
